import SettingsService from 'src/services/SettingsService';
import PublicService from 'src/services/PublicService'
export default {
  methods: {
    mapSettings(settings) {
      settings.forEach(setting => {
        if(this.model[setting.key] !== undefined) {
          this.model[setting.key] = setting.value;
        }
      })
    },
    async updateSettings() {
      let data = {
        ...this.model
      }
      for (let key in data) {
        if (!data[key]) {
          delete data[key]
        }
      }
      await SettingsService.updateSettings(data);
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      await PublicService.updateApiHost()
      let {data} = await SettingsService.get({limit: 200});
      if (data) {
        next(vm => {
          vm.mapSettings(data);
        })
      } else {
        next(vm => vm.error = 'No data');
      }
    } catch (e) {
      next(vm => vm.error = e);
    }
  },
}
